import { DateTime, Interval } from "luxon";
import i18n from "@/i18n";
import EventModule from "../planning/eventStore";
import LeavePeriodModule from "../planning/leavePeriodStore";

import {
  addInterventionFollowedHttp,
  updateInterventionFollowedHttp,
  deleteInterventionFollowedHttp,
  countInterventionsFollowedByUserTypeHttp,
  getAllInterventionsFollowedByUserTypeAndDateRangeHttp,
  fetchAllInterventionsFollowedDG2Http,
  getAllInterventionsFollowedByInterventionIdHttp,
} from "../../services/planning/InterventionFollowedService";

const state = {
  interventionsFollowed: [],
  selectedInterFollowed: null,
};

const getters = {
  getInterventionsFollowed(state) {
    return state.interventionsFollowed;
  },
  getSelectedInterFollowed(state) {
    return state.selectedInterFollowed;
  },
};

const mutations = {
  SET_INTERVENTIONFOLLOWED: (state, data) =>
    (state.interventionsFollowed = data),

  SET_SELECTED_INTER_FOLLOWED: (state, data) =>
    (state.selectedInterFollowed = data),

  NEW_INTERVENTIONFOLLOWED: (state, payload) => {
    state.interventionsFollowed.push(payload);
  },

  EDIT_INTERVENTIONFOLLOWED: (state, payload) => {
    let index = state.interventionsFollowed.findIndex(
      (e) => e.details.id === payload.details.id
    );
    if (index !== -1) state.interventionsFollowed.splice(index, 1, payload);
  },

  REMOVE_INTERVENTIONFOLLOWED: (state, payload) => {
    let index = state.interventionsFollowed.findIndex(
      (e) => e.details.id === payload
    );
    if (index !== -1) state.interventionsFollowed.splice(index, 1);
  },
  REMOVE_INTERVENTIONFOLLOWED_FOR_INTERVENTION_ID: (state, interventionId) => {
    let interFollowToRemove = state.interventionsFollowed.filter(
      (intFollow) => intFollow.details.interventionId === interventionId
    );
    interFollowToRemove.forEach((element) => {
      let index = state.interventionsFollowed.findIndex(
        (e) => e.details.id === element.details.id
      );
      state.interventionsFollowed.splice(index, 1);
    });
  },
};

const actions = {
  /**
   * This method will create the event object necessary for the proper functioning of the calendar in the Front-End.
   *
   * @param  {Vuex} {rootGetters} necessary if call getters from another store
   * @param  {Object - interventionFollowedDto} interventionFollowed event received from the Rest API that we need to transform in order to be able to be used in the calendar
   * @returns {Object - event Front-End} return an event that can be used by the calendar in the Front-End
   */
  async createFrontInterventionFollowedObject(
    { rootGetters },
    interventionFollowed
  ) {
    let iFollowed = interventionFollowed;
    let interv = iFollowed.advInterventionDto;

    const dateStart = new DateTime.fromISO(interv.dateStart);
    const dateEnd = new DateTime.fromISO(interv.dateEnd).plus({ days: 1 });

    const posY = await rootGetters["userModule/getOnUserDisplay"].findIndex(
      (u) => u.id === iFollowed.userDto.id
    );
    const duration = new Interval.fromDateTimes(dateStart, dateEnd).length(
      "days"
    );

    let event = {
      y: posY,
      x: interv.dateStart,
      id: "INTERFOLLOW" + iFollowed.id,
      duration: duration,
      display: true,
      details: iFollowed,
      color: interv.location.color,
      userType: rootGetters["userModule/getCalendar"],
      location: interv.location.city,
      userName: iFollowed.userDto.fullName,
      course: interv.course.title,
      registrationSlug: iFollowed.registrationSlug,
    };
    return event;
  },

  /**
   * This method will load interventions Followed present between the interval (currentDate - 2 months) to (currentDate + 2 months)
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} getters necessary if call getters inside the method
   * @param  {Vuex} rootGetters necessary if call getters from another store
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @param  {} currentDate the date where the client is located in the calendar
   * @returns {} it is returning nothing because the response will be load in the store directly
   */
  async loadInterventionsFollowed(
    { commit, getters, rootGetters, dispatch },
    currentDate
  ) {
    let timePrediod = rootGetters["eventModule/getTimePeriod"];
    let dateStart = null;
    let dateEnd = null;

    switch (timePrediod) {
      case "year":
        if (currentDate != null || currentDate != undefined)
          currentDate = DateTime.fromISO(currentDate).startOf("year");
        else
          currentDate = DateTime.fromISO(getters.getStartingDay)
            .startOf("year")
            .plus({ year: 1 });

        dateStart = currentDate.minus({ week: 1 }).toISODate();
        dateEnd = currentDate.plus({ year: 1 }).plus({ week: 1 }).toISODate();
        break;
      case "quarter":
        if (currentDate != null || currentDate != undefined)
          currentDate = DateTime.fromISO(currentDate).startOf("quarter");
        else
          currentDate = DateTime.fromISO(getters.getStartingDay)
            .startOf("quarter")
            .plus({ quarter: 1 });

        dateStart = currentDate.minus({ week: 1 }).toISODate();
        dateEnd = currentDate
          .plus({ quarter: 1 })
          .plus({ week: 1 })
          .toISODate();
        break;
      case "month":
        if (currentDate != null || currentDate != undefined)
          currentDate = DateTime.fromISO(currentDate).startOf("month");
        else
          currentDate = DateTime.fromISO(getters.getStartingDay)
            .startOf("month")
            .plus({ month: 1 });

        dateStart = currentDate.minus({ week: 1 }).toISODate();
        dateEnd = currentDate.plus({ month: 1 }).plus({ week: 1 }).toISODate();
        break;
      case "week":
        if (currentDate != null || currentDate != undefined)
          currentDate = DateTime.fromISO(currentDate).startOf("week");
        else
          currentDate = DateTime.fromISO(getters.getStartingDay)
            .startOf("week")
            .plus({ week: 1 });

        dateStart = currentDate.minus({ week: 1 }).toISODate();
        dateEnd = currentDate.plus({ week: 1 }).toISODate();
        break;
    }

    let count = await dispatch("countInterventionsFollowed");

    if (
      count >
      getters.getInterventionsFollowed.filter(
        (e) => e.details.userDto.type === rootGetters["userModule/getCalendar"]
      ).length
    ) {
      const promise =
        await getAllInterventionsFollowedByUserTypeAndDateRangeHttp(
          rootGetters["userModule/getCalendar"],
          dateStart,
          dateEnd
        );

      const promises = promise.data.map((e) => {
        return dispatch("createFrontInterventionFollowedObject", e);
      });
      state.interventionsFollowed = await Promise.all(promises);
    }
  },
  /**
   * This method will give the number of events depending of the calendar selecteced (trainer, salesperson, admin, etc)
   *
   * @param  {Vuex} {rootGetters} necessary if call getters from another store
   * @returns {int} it is returning the number of events depending of the calendar selecteced
   */
  async countInterventionsFollowed({ rootGetters }) {
    let nb = await countInterventionsFollowedByUserTypeHttp(
      rootGetters["userModule/getCalendar"]
    )
      .then((response) => {
        return response.data.nb;
      })
      .catch((error) => {
        return error;
      });
    return nb;
  },

  /**
   * This method will delete the interventionsFollowed passed as parameter
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param {number} interventionFollowedID - Id of the interventionFollowed that we want to delete
   * @returns - a message depending on whether it is succesfully deleted or not
   */
  async deleteInterventionFollowed(
    { commit, dispatch },
    interventionFollowedId
  ) {
    await deleteInterventionFollowedHttp(interventionFollowedId)
      .then((response) => {
        if (response.status === 200) {
          commit("REMOVE_INTERVENTIONFOLLOWED", interventionFollowedId);
          // let messageWS = {
          //   type: "DELETE",
          //   id: JSON.stringify(interventionFollowedId),
          //   event: null,
          // };
          // dispatch(
          //   "websocketModule/sendMessageToWebsocket",
          //   { messageWS },
          //   { root: true }
          // );
          dispatch(
            "notificationModule/showNotification",
            {
              messageAlert: i18n.t(
                "messageStores.interventionFollowedDeleteSuccess",
                {
                  id: interventionFollowedId,
                }
              ),
              typeAlert: "success",
            },
            { root: true }
          );
        }
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t(
              "messageStores.interventionFollowedDeleteError"
            ),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to add an interventionFollowed in the database and then in the Vuex store
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @param  {Object - InterventionsFollowedDto} interventionFollowed object that we want to add in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("NEW_EVENT", res)
   */
  async createInterventionFollowed({ commit, dispatch }, interventionFollowed) {
    await addInterventionFollowedHttp(interventionFollowed)
      .then((response) => {
        dispatch("createFrontInterventionFollowedObject", response.data).then(
          (res) => {
            commit("NEW_INTERVENTIONFOLLOWED", res);
            // let messageWS = {
            //   type: "ADD",
            //   id: JSON.stringify(res.id),
            //   interventionFollowed: JSON.stringify(res),
            // };
            // dispatch(
            //   "websocketModule/sendMessageToWebsocket",
            //   { messageWS },
            //   { root: true }
            // );
          }
        );
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t(
              "messageStores.interventionFollowedAddSuccess"
            ),
            typeAlert: "success",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.interventionFollowedAddError"),
            typeAlert: "error",
          },
          { root: true }
        );
        if (error.response.data.length > 0) {
          error.response.data.forEach((error) => {
            for (const [key, value] of Object.entries(i18n.t("errorBackend"))) {
              if (error.type === key) {
                for (const [keyE, valueE] of Object.entries(value)) {
                  if (keyE === "message")
                    dispatch(
                      "notificationModule/showErrorMessages",
                      { valueE },
                      { root: true }
                    );
                }
              }
            }
          });
        }
      });
  },
  /**
   * This method is calling the http call to edit an interventionFollowed in the database and then in the VueX store
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @param  {Object - interventionFollowedDto} interventionFollowed object that we want to edit in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("EDIT_INTERVENTIONFOLLOWED", res)
   */
  async editInterventionFollowed({ commit, dispatch }, interventionFollowed) {
    const editedInterventionFollowed = {
      id: interventionFollowed.id,
      userDto: interventionFollowed.userDto,
      advInterventionDto: interventionFollowed.advInterventionDto,
      registrationSlug: interventionFollowed.duration,
      version: interventionFollowed.version,
    };

    await updateInterventionFollowedHttp(editedInterventionFollowed)
      .then((response) => {
        dispatch("createFrontInterventionFollowedObject", response.data).then(
          (result) => commit("EDIT_INTERVENTIONFOLLOWED", result)
        );
        // let messageWS = {
        //   type: "UPDATE",
        //   id: JSON.stringify(editedInterventionFollowed.id),
        //   event: null,
        // };
        // dispatch(
        //   "websocketModule/sendMessageToWebsocket",
        //   { messageWS },
        //   { root: true }
        // );
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t(
              "messageStores.interventionFollowedEditSuccess",
              {
                id: editedInterventionFollowed.id,
              }
            ),
            typeAlert: "success",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.interventionFollowedEditError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },

  /**
   * This method is calling the http call to fetch interventionsFollowed from the webservice Wdg2 (create or update depending if the course exists or not)
   *
   * @param  {Vuex} {dispatch} necessary if call dispatch inside the method
   * @param  {Object - LogInUser} logInUser user dg2
   * @param  {Number} year selected year import
   * @returns {} it is returning nothing. The database is updated directly in the Back-End when the method is called.
   */
  async fetchInterventionsFollowedDG2({ dispatch }, { logInUser, year }) {
    await fetchAllInterventionsFollowedDG2Http(logInUser, year)
      .then((response) => {
        if (response.status === 202) {
          dispatch("loadInterventionsFollowed");
          dispatch(
            "notificationModule/showNotification",
            {
              messageAlert: i18n.t("messageStores.userAllSuccess"),
              typeAlert: "success",
            },
            { root: true }
          );
        }
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.userAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },

  async setSelectedInterFollowed({ commit }, interFollowedId) {
    if (interFollowedId) {
      let selectedInterventionObject = state.interventionsFollowed.filter(
        (i) => i.details.id === interFollowedId
      );
      commit("SET_SELECTED_INTER_FOLLOWED", selectedInterventionObject[0]);
    } else {
      commit("SET_SELECTED_INTER_FOLLOWED", null);
    }
  },

  async reloadInterventionFollowedByInterventionId(
    { commit, dispatch },
    interventionId
  ) {
    getAllInterventionsFollowedByInterventionIdHttp(interventionId).then(
      (result) => {
        if (result.status === 200) {
          result.data.forEach((element) => {
            dispatch("createFrontInterventionFollowedObject", element).then(
              (interfollowTransformed) => {
                commit("EDIT_INTERVENTIONFOLLOWED", interfollowTransformed);
              }
            );
          });
        }
      }
    );
  },
};

const methods = {
  /**
   * This method checks if a given event is overlaping with existing interventionsFollowed
   * @param {string} startDate date of the beggining of event to test
   * @param {Object} event event to test
   * @param {Object} user user whose interventionsFollowed we want to test
   * @returns a boolean true if there are no overlaping interventionsFollowed, false if there are overlaping interventionsFollowed
   */
  intervalIsEmptyInterventionFollowed(startDate, event, user) {
    const duration = event.duration - 1;
    let start = new Date(startDate);
    let end = new Date(startDate);
    end.setDate(end.getDate() + duration);
    let isEmpty = true;

    state.interventionsFollowed
      .filter((intFollow) => intFollow.details.userDto.id === user.id)
      .forEach((intFollow) => {
        const intFollowStart = new Date(
          intFollow.details.advInterventionDto.dateStart
        );
        const intFollowEnd = new Date(
          intFollow.details.advInterventionDto.dateEnd
        );

        if (intFollowStart <= end && intFollowEnd >= start) {
          isEmpty = false;
        }
      });
    return isEmpty;
  },
  /**
   * This method checks if a given event is overlaping with existing interventionsFollowed
   * @param {string} startDate date of the beggining of event to test
   * @param {string} endDate date of the end of event to test
   * @param {int} eventId optional parameter, representing the Id of the followed intervention we want to exclude from check
   * (in order to avoid conflicting with itself)
   * @param {Object} user whose interventionsFollowed we want to test
   * @returns a boolean true if there are no overlaping interventionsFollowed, false if there are overlaping interventionsFollowed
   */
  intervalIsEmptyIntFollowStartEnd(startDate, endDate, user, eventId) {
    eventId = eventId || null;
    let start = new Date(startDate);
    let end = new Date(endDate);
    let isEmpty = true;

    state.interventionsFollowed
      .filter(
        (intFollow) =>
          intFollow.details.userDto.id === user.id && intFollow.id !== eventId
      )
      .forEach((intFollow) => {
        const intFollowStart = new Date(
          intFollow.details.advInterventionDto.dateStart
        );
        const intFollowEnd = new Date(
          intFollow.details.advInterventionDto.dateEnd
        );

        if (intFollowStart <= end && intFollowEnd >= start) {
          isEmpty = false;
        }
      });
    return isEmpty;
  },

  checkIfInterventionFollowedOverlapsWithOtherEvents(
    user,
    start,
    end,
    interFollowed
  ) {
    let result = "";
    let temporaryError = false;
    const elementUser = { id: user.id };
    const elementUserName = user.fullname;

    let temporaryMessage = elementUserName + " : ";
    if (
      !EventModule.methods.intervalIsEmptyStartAndEnd(
        start,
        end,
        0,
        "",
        elementUser
      )
    ) {
      temporaryMessage += i18n.t("errorDialog.trainingsConflict") + " ; ";
      temporaryError = true;
    }
    if (
      !this.intervalIsEmptyIntFollowStartEnd(
        start,
        end,
        elementUser,
        interFollowed.id
      )
    ) {
      temporaryMessage += i18n.t("errorDialog.interFollow") + " ; ";
      temporaryError = true;
    }
    if (
      !LeavePeriodModule.methods.intervalIsEmptyLeavePeriodStartEnd(
        start,
        end,
        elementUser
      )
    ) {
      temporaryMessage += i18n.t("errorDialog.leavePeriod") + " ; ";
      temporaryError = true;
    }
    if (temporaryError) {
      result += temporaryMessage;
    }
    return result;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  methods,
};
